<template>
  <div>
    <wui-btn
      variant="negative"
      state="alpha"
      data-test="remove-button"
      prepend-icon="trashM"
      auto-loading
      icon
      @click="onRemove(guid)"
    />
  </div>
</template>
<script setup lang="ts">
import { useRenderNotifier, WuiBtn } from '@wui/common-library'

import { useBlackWhiteListStore } from '@/entities/black-white-list'

import { useLocalization } from '@/shared/composables/localization'

defineProps<{
  guid: string
}>()

const { remove } = useBlackWhiteListStore()
const { notifyError, notifySuccess } = useRenderNotifier()
const { t } = useLocalization()

const onRemove = async (guid: string) => {
  try {
    await remove(guid)
    notifySuccess(t('common.successRemove'))
  } catch {
    notifyError(t('common.failedToRemoveElement'))
  }
}
</script>
